// src/pages/EquipmentGroupDirectory.js

import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  getEquipmentGroup,
  createEquipmentGroup,
  updateEquipmentGroupName,
  deleteEquipmentGroup,
  getEquipment,
  getEquipmentInGroup,
  updateEquipmentGroupEquipment,
} from "../api/enterprise";
import UnifiedDirectory from "../components/UnifiedDirectory"; // Импортируем новый модуль
import { notifyError } from "../utils/toasts";

function EquipmentGroupDirectory({ divisionId }) {
  const { t } = useTranslation();
  const [equipmentGroups, setEquipmentGroups] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [selectedEquipmentIds, setSelectedEquipmentIds] = useState([]);

  useEffect(() => {
    try {
      const fetchEquipmentGroups = async () => {
        if (divisionId) {
          try {
            const result = await getEquipmentGroup(divisionId);
            setEquipmentGroups(result);
          } catch (error) {
            notifyError(error?.response?.data?.message || error.message);
          }
        }
      };
      fetchEquipmentGroups();
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  }, [divisionId]);

  // Мемоизируем функцию fetchEquipmentList
  const fetchEquipmentList = useCallback(async () => {
    if (divisionId) {
      try {
        const equipment = await getEquipment(divisionId);
        // Преобразуем данные для использования в CheckboxList
        const formattedEquipment = equipment.map((eq) => ({
          id: eq.equipment_id,
          name: eq.name,
        }));
        setEquipmentList(formattedEquipment);
      } catch (error) {
        notifyError(error?.response?.data?.message || error.message);
      }
    }
  }, [divisionId]);

  // Мемоизируем функцию fetchItemAssociations
  const fetchItemAssociations = useCallback(async (groupId) => {
    try {
      const groupData = await getEquipmentInGroup(groupId);
      const equipmentInGroup = groupData.equipment_in_group || [];
      // Преобразуем данные для использования в CheckboxList
      return equipmentInGroup.map((eq) => ({
        id: eq.equipment_id,
        name: eq.name,
      }));
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  }, []);

  // Мемоизируем функцию updateItemAssociations
  const updateItemAssociations = useCallback(async (groupId, equipmentIds) => {
    console.log("updateItemAssociations groupId", groupId)
    await updateEquipmentGroupEquipment(groupId, equipmentIds);
  }, []);

  const handleAddEquipmentGroup = async (name) => {
    try {
      const newGroup = await createEquipmentGroup(
        divisionId,
        name,
        selectedEquipmentIds
      );
      const result = await getEquipmentGroup(divisionId);
      setEquipmentGroups(result);
      return newGroup;
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleEditEquipmentGroup = async (item, newName) => {
    try {
      await updateEquipmentGroupName(item.equipment_group_id, newName);
      const result = await getEquipmentGroup(divisionId);
      setEquipmentGroups(result);
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  const handleDeleteEquipmentGroup = async (item) => {
    try {
      await deleteEquipmentGroup(item.equipment_group_id);
      const result = await getEquipmentGroup(divisionId);
      setEquipmentGroups(result);
    } catch (error) {
      notifyError(error?.response?.data?.message || error.message);
    }
  };

  return (
    <UnifiedDirectory
      title={t("equipment_group")}
      data={equipmentGroups}
      onAdd={handleAddEquipmentGroup}
      onEdit={handleEditEquipmentGroup}
      onDelete={handleDeleteEquipmentGroup}
      fields={["name"]}
      displayFields={["name", "upserted_at"]}
      divisionId={divisionId}
      associatedList={equipmentList}
      fetchAssociatedList={fetchEquipmentList}
      fetchItemAssociations={fetchItemAssociations}
      updateItemAssociations={updateItemAssociations}
      associatedIdsState={selectedEquipmentIds}
      associatedIdsSetter={setSelectedEquipmentIds}
      associatedLabel="select_equipment"
      itemIdKey="equipment_group_id"
    />
  );
}

export default EquipmentGroupDirectory;
